const _version = "3.8.4"
function version() {
    return _version
}
export default version
